var ajaxService = require('./ajaxService');
var endpoint = '../request';

function serializedRequestSender(serializedRequests) {
	return ajaxService(serializedRequests, endpoint);
}

module.exports = serializedRequestSender;